module.exports = __webpack_public_path__ + "static/media/disagio1.76785c24.png";